import {Grid} from "@mui/material";
import {AppCrudTable} from "@components";
import {userSettingSitesGroupData} from "../@signals";
import React from "react";
import {actionsColumn, nameColumn, sitesNameColumn} from "./columns";
import UserSettingSitesGroupTabButton from "./Button";
import UserSettingSitesGroupDrawer from "./Drawer";
import { isTourDemoActive } from "@signals/app"

export default function UserSettingsSitesGroupTab() {
    return <Grid container spacing={1}>
        <Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
            <UserSettingSitesGroupTabButton />
        </Grid>

        {(!isTourDemoActive.value || !!userSettingSitesGroupData.value?.length) && <Grid item xs={12}>
            <AppCrudTable
                title="Your Sites Group"
                data={userSettingSitesGroupData.value}
                columns={[
                    nameColumn(),
                    sitesNameColumn(),
                    actionsColumn()
                ]}
            />
        </Grid>}

        <UserSettingSitesGroupDrawer />
    </Grid>
}